import { Flex, Box, Heading, Text } from "@chakra-ui/react";
import { EVE_NG_PRICING_TYPES } from "./constants";
import { SectionDivider } from "app/components/shared/SectionDivider";
import Link from "next/link";
import { HiCalculator } from "@onemind-services-llc/react-icons-ng/hi";

const EveNgPricingTypes = () => {
  return (
    <Flex direction="column" data-cy="section-pricing-types">
      <SectionDivider
        label={"Choose Your EVE-NG Edition: Tailored Solutions for Every Need"}
      />
      <Flex flexWrap="wrap" justifyContent="center" gap={"2%"} data-cy={"card-pricing"}>
        {EVE_NG_PRICING_TYPES.map((data, index) => (
          <Box
            p={6}
            key={index}
            boxShadow={"md"}
            border={"1px solid #aaa"}
            borderRadius={"8px"}
            transition={"0.15s"}
            _hover={{
              transform: "scale(1.03)",
              boxShadow: "lg",
            }}
            height={"auto"}
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={"4px"}
            minWidth={"320px"}
            maxWidth={"23%"}
            marginBottom={6}
          >
            <Heading
              as={"h3"}
              textAlign={"center"}
              fontSize={{ base: "md", lg: "lg" }}
              color={"gray.700"}
              mb={3}
            >
              {data.title}
            </Heading>

            <Text key={index} fontSize={{ base: "md", lg: "lg" }} color={"gray.700"}>
              {data.desc}
            </Text>
          </Box>
        ))}
      </Flex>

      <Text
        // color={"#1E90FF"}
        fontWeight={"500"}
        fontSize={{ base: "md", lg: "lg" }}
        textAlign={"center"}
      >
        *All options come with savings on annual billing. (Check{" "}
        <Link
          href="#section-pricing"
          style={{
            color: "#4299e1",
            fontSize: "20px",
            textDecoration: "underline",
          }}
        >
          {" "}
          Pricing
        </Link>{" "}
        below)*
      </Text>
      <Flex
        direction={{ base: "column", lg: "row" }}
        justifyContent={"center"}
        alignItems={"center"}
        fontWeight={"500"}
        fontSize={"20px"}
        textAlign={"center"}
        mt={"1rem"}
      >
        Not sure which to choose? Use our{" "}
        <Link
          href="https://rc.cloudmylab.com/"
          style={{
            color: "#4299e1",
            fontSize: "22px",
            fontWeight: "500",
            textDecoration: "underline",
            paddingLeft: "6px",
            paddingRight: "6px",
          }}
          target="_blank"
        >
          <Flex align={"center"}>
            {" "}
            Resource Calculator <HiCalculator style={{ marginRight: "2px" }} />
          </Flex>
        </Link>{" "}
        to estimate the best fit for your project demands.{" "}
      </Flex>
    </Flex>
  );
};

export default EveNgPricingTypes;
